var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultUserPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFF2E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12V14V12ZM30 46V48V46ZM48 30H46H48ZM14 30H12H14ZM42.728 42.728L41.314 41.314L42.728 42.728ZM18.686 18.686L17.272 17.272L18.686 18.686ZM42.728 17.272L41.314 18.686L42.728 17.272ZM18.686 41.314L17.272 42.728L18.686 41.314ZM38 30C38 32.1217 37.1571 34.1566 35.6569 35.6569C34.1566 37.1571 32.1217 38 30 38C27.8783 38 25.8434 37.1571 24.3431 35.6569C22.8429 34.1566 22 32.1217 22 30C22 27.8783 22.8429 25.8434 24.3431 24.3431C25.8434 22.8429 27.8783 22 30 22C32.1217 22 34.1566 22.8429 35.6569 24.3431C37.1571 25.8434 38 27.8783 38 30V30Z",
    stroke: "#FFBF08",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUserPhoto);
export default __webpack_public_path__ + "static/media/defaultUserPhoto.aa91e1d0881f6f95e9e9de4c1efad2ea.svg";
export { ForwardRef as ReactComponent };